import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';

import { ProjectContextService } from '../../services/project-context/project-context.service';

export const projectSelectedGuard: CanActivateFn = (route, state) => {
  const projectContext = inject(ProjectContextService);
  const router = inject(Router);

  return projectContext.selectedProjectId$.pipe(
    take(1),
    map((projectId) => {
      if (projectId) {
        return true;
      }
      return router.createUrlTree(['/select-project'], { queryParams: { returnUrl: state.url } });
    })
  );
};

